<template>
  <div>
    <b-loading
        v-model="isLoading"
        :can-cancel="false"
        :is-full-page="true"
    ></b-loading>
    <div class="p-5" style="padding-bottom: 250px !important; ">
      <div class="is-flex mb-4">
        <b-tag v-if="localData" type="is-danger" class="mr-2 mt-1">Preview</b-tag>
        <div class="is-size-5 has-text-weight-semibold">{{selectedDevice.siteName}}</div>
        <b-field class="file is-info ml-auto" :class="{'has-name': !!file}">
          <b-upload v-model="file" class="file-label" @input="handleFileUpload">
            <span class="file-cta">
                <b-icon class="file-icon" icon="upload"></b-icon>
                <span class="file-label">Upload validation file (.xlsx, .xls)</span>
            </span>
            <span class="file-name" v-if="file">
                {{ file.name }}
            </span>
          </b-upload>
        </b-field>
        <b-button class="ml-2" v-if="localData" type="is-primary" icon-left="content-save"
                  @click="confirmUpload">Save Validation</b-button>
      </div>

      <div v-if="validationData" class="mt-6">
        <div v-if="directionLookup">
          <div class="is-size-5">Direction Mapping</div>
          <hr class="p-0 m-0 mb-3">
          <div class="is-flex is-flex-direction-column" style="width: 50%">
            <div v-for="direction in Object.keys(directionLookup)" :key="direction" class="is-flex is-flex-direction-row">
              <div style="width: 50%; background: #e1e1e1; border: 1px solid #8a8a8a;" class="has-text-centered has-text-weight-semibold">{{direction}}</div>
              <div style="width: 50%; background: #c2c2c2; border: 1px solid #8a8a8a;" class="has-text-centered">{{directionLookup[direction]}}</div>
            </div>
          </div>
        </div>

        <div class="is-size-5 mt-4">ValidationData</div>
        <hr class="p-0 m-0 mb-3">
        <import-validation-data-table v-for="data in getDataList()" :key="Object.keys(data)[0]"
                                      :validation-count="data"></import-validation-data-table>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import * as XLSX from 'xlsx'
import ImportValidationDataTable
  from "@/modules/data-processing-module/components/import-validation-data-table/import-validation-data-table.vue";
import {csvToObj} from "csv-to-js-parser";

export default {
  name: "import-data-validation-tmc-page",
  components: {ImportValidationDataTable},
  data() {
    return {
      isLoading: false,
      file: null,
      localData: null,
      isPreview: false
    }
  },
  mounted() {
    console.log('Selected device: ', this.selectedDevice)
  },
  methods: {
    ...mapActions({
      uploadValidationData: 'dataProcessingTmcModule/uploadTmcValidationData',
    }),
    getDataList() {
      let list = []
      if (this.validationData) {
        Object.keys(this.validationData).forEach(key => {
          let obj = {};
          obj[key] = this.validationData[key];
          list.push(obj)
        })
      }
      console.log('List: ', list)
      return list
    },
    parseSheetWithDateAndTimeStrings(worksheet) {
      const range = XLSX.utils.decode_range(worksheet['!ref']);
      const headers = [];
      const data = [];
      for (let col = range.s.c; col <= range.e.c; col++) {
        const addr = XLSX.utils.encode_cell({r: range.s.r, c: col});
        const cell = worksheet[addr];
        const header = cell?.w || cell?.v || `COL${col}`;
        headers.push(header);
      }

      for (let row = range.s.r + 1; row <= range.e.r; row++) {
        const rowData = {};
        let hasData = false;

        for (let col = range.s.c; col <= range.e.c; col++) {
          const addr = XLSX.utils.encode_cell({r: row, c: col});
          const cell = worksheet[addr];

          let value = "";

          if (cell) {
            if (cell.t === "n" && typeof cell.v === "number" && cell.v < 1.0 && cell.v > 0.0) {
              const date = XLSX.SSF.parse_date_code(cell.v);

              if (date) {
                const hasDate = date.y && date.m && date.d;
                const hasTime = date.H != null;

                if (hasDate && hasTime) {
                  value = `${date.y.toString().padStart(4, '0')}-${date.m.toString().padStart(2, '0')}-${date.d.toString().padStart(2, '0')} ${date.H.toString().padStart(2, '0')}:${date.M.toString().padStart(2, '0')}:${date.S.toString().padStart(2, '0')}`;
                } else if (hasDate) {
                  value = `${date.y.toString().padStart(4, '0')}-${date.m.toString().padStart(2, '0')}-${date.d.toString().padStart(2, '0')}`;
                } else if (hasTime) {
                  value = `${date.H.toString().padStart(2, '0')}:${date.M.toString().padStart(2, '0')}:${date.S.toString().padStart(2, '0')}`;
                } else {
                  value = String(cell.v);
                }
              } else {
                value = String(cell.v);
              }
            } else if (cell.t === "s" || cell.t === "str") {
              value = String(cell.v);
            } else if (cell.w) {
              value = cell.w;
            } else {
              value = String(cell.v ?? "");
            }
          }

          if (value !== "") hasData = true;
          rowData[headers[col - range.s.c]] = value;
        }

        if (hasData) data.push(rowData);
      }

      return data;
    },
    convertDateString(dateStr) {
      dateStr = dateStr.trim().replace(/\.$/, "");

      const [day, month, year] = dateStr.split(".");
      if (!day || !month || !year) return "";

      return `${year.padStart(4, "0")}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    transformVehicleDataFlexible(data) {
      const result = {};

      data.forEach(entry => {
        const stage = entry.parseStage;
        const time = entry.dateTime;
        const direction = entry.direction;

        if (!result[stage]) {
          result[stage] = {};
        }

        if (!result[stage][time]) {
          result[stage][time] = {};
        }

        if (!result[stage][time][direction]) {
          result[stage][time][direction] = {};
        }

        for (const key in entry) {
          if (
              ["direction", "count", "parseStage", "parseDirection", "dateTime"].includes(key)
          ) {
            continue;
          }

          const value = parseInt(entry[key], 10);
          if (!isNaN(value)) {
            if (!result[stage][time][direction][key]) {
              result[stage][time][direction][key] = 0;
            }
            result[stage][time][direction][key] += value;
          }
        }
      });

      return result;
    },
    extractDirectionMap(data) {
      const map = {};

      data.forEach(entry => {
        const dir = entry.direction;
        const parsed = entry.parseDirection;
        if (dir && parsed && !map[dir]) {
          map[dir] = parsed;
        }
      });

      return map;
    },
    handleFileUpload(file) {
      this.isLoading = true
      this.localData = null
      console.log('File: ', file)
      const reader = new FileReader();
      reader.onload = async (e) => {
        const data = new Uint8Array(e.target.result)
        const workbook = XLSX.read(data, {type: 'array', cellText: true, raw: false})
        const firsSheetName = workbook.SheetNames[0]
        const worksheet = workbook.Sheets[firsSheetName]
        let jsonData = this.parseSheetWithDateAndTimeStrings(worksheet)

        jsonData.forEach(dt => {
          if (dt['direction name'] && dt['direction name'].includes('_')) {
            let split = dt['direction name'].split('_')
            if (split.length > 1) {
              dt.parseStage = split[0]
              dt.parseDirection = split[1]
            }
          } else {
            dt.parseStage = '*'
            dt.parseDirection = dt['direction name']
          }
          dt.dateTime = `${this.convertDateString(dt.date)}T${dt.time}`
          delete dt.date
          delete dt.time
        })

        console.log('Json data: ', jsonData)

        let finalOutput = this.transformVehicleDataFlexible(jsonData)
        console.log('Final output: ', finalOutput)

        let directionsLookup = this.extractDirectionMap(jsonData)
        console.log('Directions map: ', directionsLookup)

        this.localData = {
          dataDeviceId: this.selectedDevice._id,
          directionLookup: directionsLookup,
          validationData: finalOutput
        }

        setTimeout(()=>{
          this.isLoading = false
        }, 500)

      }
      reader.readAsArrayBuffer(file);
    },
    async uploadData(){
      this.isLoading = true

      let response = await this.uploadValidationData(this.localData)

      if (response instanceof Error) {
        this.showToast(response.message, 'is-danger')
      } else {
        this.showToast('Validation Data successfully uploaded', 'is-success')
        this.localData = null
        this.file = null
      }
      this.isLoading = false
    },
    confirmUpload() {
      this.$buefy.dialog.confirm({
        type: 'is-danger',
        message: 'Are you sure?',
        confirmText: 'Yes',
        onConfirm: () => this.uploadData()
      })
    },
    showToast(message, type) {
      this.$buefy.toast.open({
        message: message,
        duration: 3000,
        type: type
      })
    }
  },
  computed: {
    ...mapGetters({
      selectedProcessingProject: 'dataProcessingTmcModule/getTmcSelectedProcessingProject',
      selectedDevice: 'dataProcessingTmcModule/getTmcSelectedProcessingDevice'
    }),
    validationData() {
      let newObj = {}

      let inputData
      if(this.localData){
        inputData = this.localData.validationData
      }else if(this.selectedDevice && this.selectedDevice.validationData){
        inputData = this.selectedDevice.validationData
      }
      if (inputData) {

        //let inputData = this.selectedDevice.validationData
        //let inputData = this.localData
        let stages = Object.keys(inputData)
        if (stages && stages.length > 0) {
          stages.forEach(stage => {
            let dates = Object.keys(inputData[stage])
            if (dates && dates.length > 0) {
              dates.forEach(date => {
                let directions = Object.keys(inputData[stage][date])
                if (directions && directions.length > 0) {
                  directions.forEach(direction => {
                    if (!newObj[date]) {
                      newObj[date] = {}
                    }
                    if (!newObj[date][stage]) {
                      newObj[date][stage] = {}
                    }
                    if (!newObj[date][stage][direction]) {
                      newObj[date][stage][direction] = {}
                    }
                    newObj[date][stage][direction] = inputData[stage][date][direction]
                  })
                }
              })
            }
          })
        }
        console.log('New object', newObj)
        return newObj
      }

      return null
    },
    directionLookup(){
      let inputData
      if(this.localData){
        inputData = this.localData.directionLookup
      }else if(this.selectedDevice && this.selectedDevice.validationData){
        inputData = this.selectedDevice.directionLookup
      }

      return inputData
    }
  }
}
</script>

<style scoped>

</style>